import React from 'react';
import './LobbyIsFullModal.css';
import PageButton from '../../elements/PageButton/PageButton';

const PAGE_ID = 'LobbyIsFullModal';

/**
 * Отказ входа в лобби, где уже собран полный состав (ответ сервера
 * LOBBY_IS_FULL). Ботов ради вошедшего не вытесняют; места живым игрокам
 * сервер оставляет сам — больше четырех ботов он в лобби не сажает.
 */
function LobbyIsFullModal({maxPlayers, onHide}) {
  return (
    <div className="lobby-is-full-overlay" onClick={onHide} role="dialog" aria-modal="true">
      <div className="lobby-is-full-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="lobby-is-full-title">Лобби заполнено</h2>
        <p className="lobby-is-full-text">
          В этом лобби уже максимальное количество игроков:{' '}
          <span className="text-coins">{maxPlayers}</span>
        </p>

        <div className="main-menu-buttons lobby-is-full-buttons">
          <PageButton onClick={onHide} pageId={PAGE_ID} buttonId="hide">
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default LobbyIsFullModal;
